export default __webpack_public_path__ + "images/OracleIMTile.svg";